import { List } from "@mantine/core";
import "./TermsAndPrivacy.css";

const Terms: React.FC = () => {
  return (
    <div className="terms-and-privacy-container">
      <div className="terms-and-privacy-title">
        Opći uvjeti ugovora za kupce
      </div>
      <div className="terms-and-privacy-updated">
        Posljednje ažurirano: 6. svibnja 2025.
      </div>

      <section className="terms-and-privacy-section">
        <div className="terms-and-privacy-subtitle">
          Uvodne odredbe i definicije ugovornih pojmova
        </div>
        <div className="terms-and-privacy-paragraph">
          Za potrebe tumačenja ovih Općih uvjeta pojedini pojmovi imaju sljedeće
          značenje:
        </div>

        <div className="terms-and-privacy-paragraph">
          <strong>„CoreEvent"</strong> je trgovačko društvo registrirano po
          hrvatskom pravu pod nazivom tvrtke CoreEvent d.o.o. u sudskom registru
          Trgovačkog suda u Zagrebu pod OIB: 36611335369 i MBS: 081377997, sa
          sjedištem u Zagrebu, Dunjevac 15, koje u ime i za račun Prodavatelja
          pregovara i sklapa ugovore o prodaji Digitalnog sadržaja i Pretplate s
          Kupcima (trećim osobama).
        </div>

        <div className="terms-and-privacy-paragraph">
          <strong>„Prodavatelj"</strong> je Dinamo Trade d.o.o. u čije ime i za
          čiji račun CoreEvent putem Portala pregovara i sklapa ugovore o
          prodaji Digitalnog sadržaja i Pretplate s Kupcima (trećim osobama) u
          ime i za račun Prodavatelja kao nalogodavca.
        </div>

        <div className="terms-and-privacy-paragraph">
          <strong>„Digitalni sadržaj"</strong> odnosni se na digitalne revije i
          publikacije koje se mogu kupiti i čitati putem Portala.
        </div>

        <div className="terms-and-privacy-paragraph">
          <strong>„Pretplata"</strong> je svaka pretplata koju Kupac može kupiti
          putem Portala, a odnosi se na digitalne revije. Vrijeme trajanja
          pretplate definira Prodavatelj te je ono jasno naznačno na Portalu.
          Kupnjom pretplate Kupac ostvaruje pravo na čitanje svakog broja
          digitalne revije izdanog za vrijeme trajanja pretplate. Nakon isteka
          razdoblja važenja prethodno kupljene Pretplate, ista se ne obnavlja
          automatski niti se automatski naplaćuje. Kupac je odgovoran za ručno
          obnavljanje Pretplate ako želi nastaviti korištenje usluga Pretplate.
        </div>

        <div className="terms-and-privacy-paragraph">
          <strong>„Kupac"</strong> znači treća osoba odnosno fizička i/ili
          pravna osoba koja je izvršila kupnju Digitalnih sadržaja i/ili
          Pretplate putem Portala.
        </div>

        <div className="terms-and-privacy-paragraph">
          <strong>„Portal"</strong> znači elektronički sustav CoreEventa-a za
          prodaju Digitalnog sadržaja i Pretplata u ime i za račun Prodavatelja
          putem Internet stranice Digitalne revije
          https://drevija.gnkdinamo.hr/.
        </div>

        <div className="terms-and-privacy-paragraph">
          Korištenjem Portala Kupac potvrđuje da je upoznat s ovim Uvjetima
          poslovanja te da ih u cijelosti prihvaća. CoreEvent zadržava pravo
          izmjene ovih Uvjeta poslovanja u bilo kojem trenutku, a izmjene
          stupaju na snagu odmah nakon objave na Portalu.
        </div>
      </section>

      <section className="terms-and-privacy-section">
        <div className="terms-and-privacy-subtitle">
          Prodaja i korištenje Digitalnog sadržaja
        </div>
        <div className="terms-and-privacy-paragraph">
          Putem Portala se u ime i za račun Prodavatelja mogu kupiti digitalne
          revije, publikacije i Pretplate prema cjeniku kojeg određuje
          Prodavatelj.
        </div>

        <div className="terms-and-privacy-paragraph">
          Sve cijene izražene su u eurima (€), s uključenim PDV-om.
        </div>

        <div className="terms-and-privacy-paragraph">
          Kupnjom Pretplate odmah se plaća cijela cijena Pretplate.
        </div>

        <div className="terms-and-privacy-paragraph">
          Digitalni sadržaj koji Kupac kupi putem Portala pojedinačno ili preko
          Pretplate dostupan je i može se koristiti isključivo u sustavu
          Portala.
        </div>

        <div className="terms-and-privacy-paragraph">
          Kupovinom Digitalnog sadržaja i/ili Pretplate Kupac bezuvjetno
          prihvaća i sljedeća prava i obveze:
        </div>

        <List withPadding listStyleType="disc">
          <List.Item className="terms-and-privacy-list-item">
            povrat i zamjena Digitalnog sadržaja i/ili Pretplate nakon kupnje
            nije moguć, osim ako Prodavatelj nije odredio drugačije;
          </List.Item>
          <List.Item className="terms-and-privacy-list-item">
            brisanjem korisničkog računa, Kupac više nema pristup Portalu te
            tako i kupljenom Digitalnom sadržaju, osim ako Prodavatelj nije
            odredio drugačije;
          </List.Item>
          <List.Item className="terms-and-privacy-list-item">
            neovlašteno korištenje Digitalnog sadržaja izvan sustava Portala te
            bilo kakvo umnožavanje i/ili objavljivanje Digitalnog sadržaja bez
            izričitog odobrenja Prodavatelja strogo je zabranjeno te u slučaju
            istog Kupcu može biti izbrisan korisnički račun, zabranjen pristup
            kupljenom sadržaju bez prava na bilo kakvu naknadu te mogu biti
            poduzete legalne mjere od strane Prodavatelja;
          </List.Item>
        </List>

        <div className="terms-and-privacy-paragraph">
          Na sve pravne odnose koji nisu regulirani ovim Uvjetima, a tiču se
          odnosa između Kupca i Prodavatelja, primjenjuje se Zakon o obveznim
          odnosima te drugo pozitivno pravo u Republici Hrvatskoj.
        </div>
      </section>

      <section className="terms-and-privacy-section">
        <div className="terms-and-privacy-subtitle">Uvjeti plaćanja</div>
        <div className="terms-and-privacy-paragraph">
          Plaćanje Digitalnog sadržaja i Pretplata moguće je izvršiti putem
          sredstava plaćanja navedenih na Portalu.
        </div>

        <div className="terms-and-privacy-paragraph">
          CoreEvent je ovlašten u bilo kojem trenutku izmijeniti dostupne načine
          plaćanja na Portalu.
        </div>

        <div className="terms-and-privacy-paragraph">
          Kupnjom Digitalnog sadržaja i/ili Pretplate Kupac ovlašćuje CoreEvent
          da putem odabranog načina plaćanja naplati ukupan iznos, koji
          uključuje cijenu Digitalnog sadržaja i/ili Pretplate te bilo koje
          druge naknade i/ili troškove.
        </div>
      </section>

      <section className="terms-and-privacy-section">
        <div className="terms-and-privacy-subtitle">
          Dostava Digitalnog sadržaja i računa
        </div>
        <div className="terms-and-privacy-paragraph">
          Nakon uspješno završene kupnje, Digitalni sadržaj će Kupcu biti
          dostupan isključivo na Portalu. Kupac kupljenom Digitalnom sadržaju
          može pristupiti preko Portala u bilo kojem trenutku u kojem je
          prijavljen sa korisničkim računom putem kojeg je kupio isti Digitalni
          sadržaj.
        </div>
        <div className="terms-and-privacy-paragraph">
          Račun za kupljeni Digitalni sadržaj i/ili Pretplatu dostupan je za
          preuzimanje preko Portala.
        </div>
      </section>

      <section className="terms-and-privacy-section">
        <div className="terms-and-privacy-subtitle">
          Uvjeti reklamacija i povrata
        </div>
        <div className="terms-and-privacy-paragraph">
          Digitalni sadržaj dostupan je Kupcu preko Portala odmah nakon kupnje
          što znači da se odmah isporučuje. Kupac je suglasan i izričito
          pristaje da izvršenjem kupnje Digitalnog sadržaja započinje isporuka
          naručenog sadržaja neposredno nakon potvrde uplate.
        </div>
        <div className="terms-and-privacy-paragraph">
          Kupac ovime potvrđuje i prihvaća da time gubi pravo na jednostrani
          raskid ugovora (povrat kupnje) jer je Digitalni sadržaj isporučen na
          nematerijalnom mediju i isporuka je započela odmah. Kupnjom Digitalnog
          sadržaja i/ili Pretplate Kupac se slaže sa tvrdnjom da se sadržaj
          isporučuje odmah i da gubi pravo na povrat.
        </div>
        <div className="terms-and-privacy-paragraph">
          Ova odredba je u skladu s člankom 16. točkom (m) Direktive 2011/83/EU
          Europskog parlamenta i Vijeća od 25. listopada 2011. te s člankom 86.
          stavkom 13. Zakona o zaštiti potrošača Republike Hrvatske (NN 19/22).
          Isporuka Digitalnog sadržaja vrši se neposredno nakon dovršene
          transakcije elektroničkim putem i time se smatra izvršenom isporukom
          ugovorne obveze.
        </div>
        <div className="terms-and-privacy-paragraph">
          U slučaju neispravnosti kupljenog Digitalnog sadržaja Kupac može
          kontaktirati CoreEvent putem kontaktnih podataka koje može pronaći na
          Portalu.
        </div>
      </section>

      <section className="terms-and-privacy-section">
        <div className="terms-and-privacy-subtitle">
          Obrada osobnih podataka
        </div>
        <div className="terms-and-privacy-paragraph">
          CoreEvent primjenjuje pravila povezana sa zaštitom pojedinaca u
          pogledu obrade osobnih podataka i pravila povezana sa slobodnim
          kretanjem osobnih podatak u skladu s Uredbom (EU) 2016/679 Europskog
          parlamenta i Vijeća od 27. travnja 2016. o zaštiti pojedinaca u vezi s
          obradom osobnih podataka i o slobodnom kretanju takvih podataka te o
          stavljanju izvan snage Direktive 95/46/EZ (Opća uredba o zaštiti
          podataka).
        </div>

        <div className="terms-and-privacy-paragraph">
          Kupac je suglasan sa sadržajem i pravima i obvezama te daje svoju
          suglasnost u pogledu obrade osobnih podataka određenih u Pravila
          zaštite osobnih podataka na internet stranicama - Digitalne revije (
          https://drevija.gnkdinamo.hr/ ).
        </div>
      </section>

      <section className="terms-and-privacy-section">
        <div className="terms-and-privacy-subtitle">Podnošenje prigovora</div>
        <div className="terms-and-privacy-paragraph">
          Sukladno odredbama čl. 10 Zakona o zaštiti potrošača, Kupac može
          pisani prigovor uputiti podnošenjem pisanog prigovora u poslovnim
          prostorijama CoreEventa na adresi sjedišta, putem pošte slanjem
          pisanog prigovora na adresu sjedišta i putem elektroničke pošte na
          email adresu{" "}
          <a href="mailto:contact@core-event.co">contact@core-event.co</a>.
        </div>

        <div className="terms-and-privacy-paragraph">
          CoreEvent će po zaprimanju pisanog prigovora od strane Kupca, istoga
          povratno obavijestiti o potvrdi primitka pisanog prigovora te će
          CoreEvent odgovoriti na prigovor u roku od 15 dana od dana zaprimanja
          prigovora.
        </div>
      </section>

      <section className="terms-and-privacy-section">
        <div className="terms-and-privacy-subtitle">
          Mjerodavno pravo, sporovi
        </div>
        <div className="terms-and-privacy-paragraph">
          Na sve pravne odnose između CoreLine-a, Kupca i Prodavatelja nastalim
          korištenjem Portala te kupnjom Digitalnog sadržaja primjenjuje se
          pravo Republike Hrvatske.
        </div>

        <div className="terms-and-privacy-paragraph">
          U slučaju eventualnih sporova nadležan će biti sud prema mjestu
          sjedišta CoreLine-a.
        </div>
      </section>
    </div>
  );
};

export default Terms;
